import ProtectedRouteSet from './protectedRouteSet.component';

export default ProtectedRouteSet;
